export default [
  'priceLimitService',
  'adListenerService',
  '$rootScope',
  function (priceLimitService, adListenerService, $rootScope) {
    return {
      require: 'ngModel',
      link(scope, element, attrs, ngModelCtrl) {
        let useValidator = false;
        let priceLimit = 0;
        let utilitiesPrice = 0;

        attrs.$observe('cianAfPriceLimitValidator', input => {
          useValidator = input === 'true';
        });

        ngModelCtrl.$validators.priceLimit = modelValue => {
          // если есть priceLimit и он не 0, то значение модели должно быть больше лимита
          if (useValidator && priceLimit) {
            return modelValue + utilitiesPrice >= priceLimit;
          } else {
            return true;
          }
        };

        $rootScope.$on(priceLimitService.events.LIMIT_UPDATED, (event, limitInfo) => {
          ({ priceLimit, utilitiesPrice } = limitInfo);
          ngModelCtrl.$validate();
        });

        $rootScope.$on(priceLimitService.events.START_LIMIT_UPDATING, () => {
          ngModelCtrl.$setValidity('priceLimit', undefined); // устанавливаем $pending статус
        });
      },
    };
  },
];
